module.exports = __webpack_public_path__ + "img/related-images-icon.1900fd10.svg";